import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import forOwn from 'lodash/forOwn';

import querystring from '../querystring';
import reducers from '../reducers';
import {dispatchAction} from '../store';

const ActionType = 'NAVIGATOR/NAVIGATE';

function navigate(objOrCallback, $element) {
    var url = window.location.href;
    if (isObject(objOrCallback)) {
        url = querystring.modify(url, function (qs) {
            forOwn(objOrCallback, function (v, k) {
                if (v === "" || typeof(v) === 'undefined' || v === null) {
                    delete qs[k];
                } else {
                    qs[k] = v;
                }
            });
        });
    } else if (isFunction(objOrCallback)) {
        url = querystring.update(url, qs => objOrCallback(qs) || qs);
    }

    if (url !== window.location.href) {
        var data = buildNavigateData($element);
        window.history.pushState(data, '', url);
        dispatchEvent(url, data);
        return true;
    }
    return false;
}

function buildNavigateData($element) {
    var ajaxElement = $element.attr('data-query-target');
    if (!ajaxElement) {
        let id = $element.closest('[data-ajax="true"]').attr('id');
        if (id) ajaxElement = '#' + id;
    }
    return {ajaxElement: ajaxElement};
}

function dispatchEvent(uri, extraData) {
    dispatchAction({type: ActionType, uri: uri, ...extraData});
}

const _callbacks = [];
// event subscription
function onNavigate(callback) {
    _callbacks.push(callback);
    return () => {
        var index = _callbacks.indexOf(callback);
        _callbacks.splice(index, 1)
    }
}

var lastUrl = window.location.href;

window.onpopstate = function (event) {
    if (window.location.href !== lastUrl) {
        dispatchEvent(window.location.href, event.state);
    }
    lastUrl = window.location.href;
};

reducers.add('nav', function (state = {}, action) {
    switch (action.type) {
        case ActionType:
            setTimeout(() => {
                _callbacks.forEach(c => c(action));
            }, 0);
    }
    return state;
});

export default {navigate, onNavigate};


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/internal/navigator.js